import { inputs } from '@ecosystem/newron-design-system';
import React from 'react';
import { ValueListType, ValueType } from '@ecosystem/newron-design-system/build/global-types/types';

export interface WithMultiSelectProps {
  options: any[];
  values: ValueListType;
  onChange: (values: string[], value: ValueType) => void;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  combobox?: boolean;
  isPrimaryLinkButtonEnabled?: boolean;
  isSecondaryLinkButtonEnabled?: boolean;
  primaryLinkButtonLabel?: string;
  secondaryLinkButtonLabel?: string;
  onPrimaryLinkButtonClick?: () => void;
  onSecondaryLinkButtonClick?: () => void;
  isVirtualizedList?: boolean;
  name?: string;
  [key: string]: any;
}

export const WithMultiSelect: React.FC<WithMultiSelectProps> = ({ options, values, onChange, ...otherProps }) => {
  const { MultiSelect } = inputs;

  return (
    <div>
      <MultiSelect options={options} values={values} onChange={onChange} combobox {...otherProps} />
    </div>
  );
};
